/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './layout-include-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../../common/controller/signal-admin-resource-list-state';
import {LayoutIncludeApiService, LayoutIncludeModel} from './layout-include-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-layout-include-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutIncludeListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.layout-includes.layout-include';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'reference'},
    {param: 'description'}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<LayoutIncludeModel>(
    inject(LayoutIncludeApiService),
    {listId: 'fullLayoutIncludeList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
